import URLConfig from "@Config/urls/url.config";
import { LinkItemProps } from "@Layouts/sidebar/AppSidebar";

const URL = URLConfig.TERMINAL_MANAGEMENT_SYSTEM.MERCHANT;

export const MerchantMenuLink: Array<LinkItemProps> = [
  {
    name: "Demande commerçant",
    link: URL.MERCHANT_REQUEST,
    level: 2,
  },
  {
    name: "Validation demande commerçant",
    link: URL.MERCHANT_REQUEST_VALIDATION,
    level: 2,
  },
  {
    name: "Consultation commerçant",
    link: URL.MERCHANT_CONSULTATION,
    level: 2,
  },
];

